// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18vTG","clinicsSelect":"styles_clinicsSelect__2gjjo"};